(function (factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['./jquery'], factory);
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('./jquery'));
    } else {
        factory(jQuery);
    }
}(function ($) {
    document.addEventListener('DOMContentLoaded', function () {
	    myFunction();
    }, false);

    $(document).ready(function() {
        showLargeComparisonImage();
        myFunction();
    });

    window.addEventListener("scroll", myFunction);

    function myFunction() {
        var popup = document.getElementById("variantPopUp");
        var footer = document.getElementsByClassName("footer")[0];

        if ((window.innerHeight + window.pageYOffset + 30 < footer.offsetTop)) {
            popup.classList.add("stick");
        }
        else {
            popup.classList.remove("stick");
        }

        showLargeComparisonImage();
    }

    function showLargeComparisonImage() {
	    //Show large image functions
	    var variantHeaderColumns = $("th.columnsVariant");
	    var variantThumbnailImage = $(".columnsVariant-thumbnail");
	    var largeImageColumn = $("#largeImageColumn");
	    var largeImageContainer = $("#largeThumbnailImageContainer");
	    var largeImage = $("#largeThumbnailImage");
	    var closeButton = $("#closeLargeImage");
        largeImageContainer.hide()
	    //Click on image thumbnail
	    variantThumbnailImage.on("click", function () {
		    variantHeaderColumns.addClass("unfocused");
		    $(this).parent().parent(".columnsVariant").removeClass("unfocused");
		    setLargeThumbnail($(this), largeImageColumn, largeImageContainer, largeImage, closeButton);
	    });

	    //Click on overview/large image close button
	    closeButton.on("click", function () {
		    variantHeaderColumns.removeClass("unfocused");
		    largeImageColumn.hide();
		    largeImageContainer.hide();
		    closeButton.hide();
	    });
    }

    //Initiates large image. Show large image, set image src and position.
    function setLargeThumbnail(imageElem, imageColumn, imageContainer, image, closeButton) {
        var imageSrc = imageElem.attr("src");
        image.attr("src", imageSrc);

        imageColumn.show();
        imageContainer.show();
        closeButton.show();

        setLargeThumbnailPosition(imageElem, imageContainer, closeButton);
    }

    //Position large image on large image column container
    function setLargeThumbnailPosition(imageElem, imageContainer) {
        var height = imageElem.parent().parent().height() + 24;
        imageContainer.attr("style", "top: " + height + "px;");
    }
}));